const state = () => ({
    caseSummary: [],
    loadingSummary: false,
    currentSlideIndex: 0
})

const mutations = {
    SET_CASE_SUMMARY: (state, summary) => {
        state.caseSummary = summary;
    },
    SET_LOADING_SUMMARY: (state, loading) => {
        state.loadingSummary = loading;
    },
    SET_CURRENT_SLIDE_INDEX: (state, index) => {
        state.currentSlideIndex = index;
    }
}

const actions = {
    goToSlide({commit}, slideIndex) {
        commit('SET_CURRENT_SLIDE_INDEX', slideIndex);
    },
    async fetchCaseSummary({commit, rootState}) {
        try {
            commit('SET_LOADING_SUMMARY', true);
            const aula = rootState.aulas.aula;
            
            if (!aula || !aula.CaseStudy_Slides) {
                commit('SET_CASE_SUMMARY', []);
                commit('SET_LOADING_SUMMARY', false);
                return;
            }

            const slides = aula.CaseStudy_Slides.sort((a, b) => (a.order || 0) - (b.order || 0));
            const topics = aula.CaseStudy_Topics ? aula.CaseStudy_Topics.sort((a, b) => a.order - b.order) : [];
            
            let summary = [];
            
            if (topics.length > 0) {
                // Usar tópicos definidos
                topics.forEach((topic, topicIndex) => {
                    const nextTopic = topics[topicIndex + 1];
                    const startSlideIndex = topic.start_slide_order;
                    const endSlideIndex = nextTopic ? nextTopic.start_slide_order - 1 : slides.length - 1;
                    
                    summary.push({
                        id: `topic-${topic.id}`,
                        name: topic.title,
                        type: 'topic',
                        slideIndex: startSlideIndex,
                        slideCount: Math.max(0, endSlideIndex - startSlideIndex + 1)
                    });
                });
            } else {
                // Fallback: gerar baseado nos slides
                summary = slides.map((slide, index) => ({
                    id: slide.id,
                    name: `Slide ${index + 1}`,
                    type: 'slide',
                    slideIndex: index,
                    hasAudio: !!slide.filename_audio,
                    commentsCount: slide.CaseStudy_Comments ? slide.CaseStudy_Comments.length : 0
                }));
            }

            commit('SET_CASE_SUMMARY', summary);
            commit('SET_LOADING_SUMMARY', false);
        } catch (error) {
            commit('SET_LOADING_SUMMARY', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: 'Erro ao carregar sumário do caso'
            });
        }
    }
}

const getters = {
    getCaseSummary: state => state.caseSummary,
    getLoadingSummary: state => state.loadingSummary,
    getCurrentSlideIndex: state => state.currentSlideIndex
}

export default {
    state,
    getters,
    mutations,
    actions
};